import { HOW_TO_USE } from "@/lib/content";
import { useReveal } from "@/lib/useReveal";

export const HowToUse = () => {
  const { ref, inView } = useReveal();
  return (
    <section className="bg-[var(--hp-charcoal)] py-12 text-white sm:py-16 lg:py-20" ref={ref}>
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className={`mb-10 text-center hp-reveal ${inView ? "in-view" : ""}`}>
          <h2 className="font-display text-3xl uppercase sm:text-4xl">How to Use</h2>
          <p className="mx-auto mt-3 max-w-2xl text-base text-white/70">
            Follow these simple steps for better results.
          </p>
        </div>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-3">
          {HOW_TO_USE.map((s, i) => (
            <div
              key={s.step}
              data-testid={`how-to-use-${i}`}
              className={`relative rounded-2xl border border-white/10 bg-white/5 p-7 hp-reveal ${
                inView ? "in-view" : ""
              }`}
              style={{ animationDelay: `${i * 0.12}s` }}
            >
              <span className="font-display text-5xl text-[var(--hp-gold-light)]">{s.step}</span>
              <h3 className="mt-3 text-lg font-bold">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/70">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
